import { fetchServiceType } from '../../../../api/others/serviceType';
const GET_SERVICETYPE_OPTIONS = 'GET_SERVICETYPE_OPTIONS';
const FETCH_STATE = 'FETCH_STATE';
const FETCH_END = 'FETCH_END';

const state = () => ({
  fetching: null,
  list: [],
});
const getters = {
  serviceTypeOptions: state => state.list,
};
const actions = {
  fetchAllOptions({ state, commit }) {
    if (state.fetching) return state.fetching;
    const fetchHandle = fetchServiceType().then(res => {
      commit(GET_SERVICETYPE_OPTIONS, res.data);
      commit(FETCH_END);
    });
    commit(FETCH_STATE, fetchHandle);
    return fetchHandle;
  },
};
const mutations = {
  [GET_SERVICETYPE_OPTIONS](state, list) {
    state.list = list;
  },
  [FETCH_STATE](state, fetchHandle) {
    state.fetching = fetchHandle;
  },
  [FETCH_END](state) {
    state.fetching = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
